//import Vue from "vue";
import * as types from "./mtypes";

export default {
  //Get Accounts
  [types.FETCH_USER_FIELDS_REQUEST](state) {
    state.fetching = true;
    state.error = null;
  },

  [types.FETCH_USER_FIELDS_SUCCESS](state, result) {
    state.fetching = false;
    state.loading = false;
    Object.assign(state.userFieldsResponse, result);
  },

  [types.FETCH_USER_FIELDS_FAILURE](state, error) {
    state.fetching = false;
    state.error = error;
    state.userFieldList = [];
  },

  [types.REQUEST_HANDLER](state) {
    state.loading = true;
  },

  [types.REQUEST_SUCCESS](state, data) {
    state.loading = false;
    state.isSucceeded = data.succeeded;
    state.resultMessage = data.resultMessage;
  },

  [types.REQUEST_FAILURE](state, data) {
    state.loading = false;
    state.isSucceeded = data.Succeeded;
    state.errorCode = data.ErrorCode;
    state.errorMessage = data.ErrorMessage;
    state.validationErrors = data.ValidationErrors;
  },
};
